import type { Module } from 'vuex'
import type { RootState } from '@/store'
import type { LocationState, LocationCoords } from './types'
import { LOCATION_ACTIONS, LOCATION_GETTERS, LocationError } from './types'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

const location: Module<LocationState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

export { LOCATION_ACTIONS, LOCATION_GETTERS, LocationError }
export type { LocationState, LocationCoords }
export default location
